// CriticalAlerts.js
import React from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { postureAlertIconChipStyle, postureAlertIconStyle, postureGlyphStyle, postureIconChipStyle } from "./iconStyles";

const CriticalAlerts = ({ threatData = [] }) => {
  // Filter top critical/high severity alerts
  const criticalAlerts = threatData
    .filter(threat => threat.asset_criticality === "Critical" || threat.asset_criticality === "High")
    .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
    .slice(0, 5);

  const getBadgeColor = (level) => {
    switch (level) {
      case "Critical": return { color: "#dc2626", backgroundColor: "#fef2f2", border: "1px solid #fecaca" };
      case "High":     return { color: "#ea580c", backgroundColor: "#fff7ed", border: "1px solid #fed7aa" };
      case "Medium":   return { color: "#d97706", backgroundColor: "#fffbeb", border: "1px solid #fde68a" };
      case "Low":      return { color: "#16a34a", backgroundColor: "#f0fdf4", border: "1px solid #bbf7d0" };
      default:         return { color: "#374151", border: "1px solid #d1d5db" };
    }
  };

  return (
    <Card style={{ background: "var(--vz-secondary-bg, #fff)", border: "1px solid var(--vz-border-color)", borderRadius: "10px", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", overflow: "hidden" }}>
      <CardHeader className="d-flex align-items-center gap-2" style={{ background: "transparent", borderBottom: "1px solid var(--vz-border-color)" }}>
        <span style={postureAlertIconChipStyle("#dc3545")}>
          <i className="ri-alert-line" style={postureAlertIconStyle("#dc3545")}></i>
        </span>
        <div>
          <h5 className="mb-0">Recent Critical Alerts</h5>
          <small className="text-muted">Latest high-priority security incidents.</small>
        </div>
      </CardHeader>
      <CardBody className="pt-0">
        <ul className="list-unstyled mt-3 mb-3">
          {criticalAlerts.length > 0 ? (
            criticalAlerts.map((alert, index) => (
              <li key={index} className="d-flex align-items-center justify-content-between py-2 border-bottom">
                <div>
                  <h6 className="mb-0 fw-semibold">{alert.asset_name || alert.ip}</h6>
                  <small className="text-muted">{alert.threat_type}</small>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <span className="badge rounded-pill py-2 px-3" style={getBadgeColor(alert.asset_criticality)}>{alert.asset_criticality}</span>
                  <small className="text-muted d-inline-flex align-items-center gap-1">
                    <span >
                      <i className="ri-time-line" style={postureGlyphStyle}></i>
                    </span>
                    {new Date(alert.timestamp).toLocaleTimeString()}
                  </small>
                </div>
              </li>
            ))
          ) : (
            <li className="text-center text-muted py-3">No critical alerts found</li>
          )}
        </ul>
        <div className="text-center">
          <a href="/ThreatFeed" className="text-danger fw-medium">
            View All Threats <span className="ms-1" style={postureIconChipStyle("#dc3545")}>
              <i className="ri-arrow-right-up-line" style={postureGlyphStyle}></i>
            </span>
          </a>
        </div>
      </CardBody>
    </Card>
  );
};

export default CriticalAlerts;
